const VideoInline = function() {

  var videoInlineBtn, videoElem, videoPoster, videos;

  function init(query) {
    var query = query || '[data-video-item]';
    videoInlineBtn = document.querySelector('[data-action="open-video-inline"]');
    videoElem = document.querySelector('[data-video-element]');
    videoPoster = document.querySelector('[data-video-poster]');
    videos = document.querySelectorAll(query);

    if (videos.length) {
      videos.forEach(video => {
        // lazyLoadPlyrStyles();
        initializeVideoItem(video);
        video.removeAttribute(query);
      })
    }

    if (videoInlineBtn && videoElem) {
      initializeEvents();
    }

  }

  function initializeEvents() {
    videoInlineBtn.addEventListener('click', (evt) => {
      evt.preventDefault();
      embedVideoElement();
    });
  }

  function embedVideoElement() {
    if (videoPoster) {
      videoPoster.style.display = 'none';
    }
    videoElem.style.display = 'block';
  }

  function initializeVideoItem(videoEl) {
    let videoPlayerElement = document.createElement('video'),
      source = document.createElement('source'),
      options = { autoplay: true, autopause: false };

    // videoEl.style.opacity = 0;

    source.setAttribute('src', videoEl.dataset.source);

    videoPlayerElement.innerHTML = source.outerHTML;
    videoPlayerElement.loop = true;
    videoPlayerElement.autoplay = true;
    videoPlayerElement.setAttribute('muted', "");
    videoPlayerElement.setAttribute('playsinline', "");
    videoPlayerElement.setAttribute('controls', "");
    videoPlayerElement.setAttribute('data-plyr-config', '{"autopause": false}');
    videoPlayerElement.setAttribute('poster', videoEl.dataset.poster);
    videoPlayerElement.dataset.poster = videoEl.dataset.poster;

    videoEl.appendChild(videoPlayerElement);

    const player = new Plyr(videoPlayerElement, options);
    player.on('playing', () => {
      // videoEl.style.opacity = 1;
      // videoEl.classList.add('pointer-events-disabled');
    });
    player.on('ready', event => {
      // debugger;
      // const _player = event.detail.plyr;
      console.log('Video Ready!');
      setTimeout(() => {
        if(!player.playing) {
          videoPlayerElement.click();
        }
      }, 1500);
    });
    // onVideoItemReady.bind(this));
  }

  // onVideoItemReady(event) {
  //     const instance = event.detail.plyr;
  //     console.log(instance);
  // }

  function lazyLoadPlyrStyles() {
    let playerCSSUrl = 'https://cdn.plyr.io/3.6.8/plyr.css',
      plyrStyles = document.getElementById('plyrStyles');

    if (!plyrStyles) {
      let link = document.createElement('link');
      link.setAttribute('id', 'plyr-styles');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('href', playerCSSUrl);
      document.head.appendChild(link);
    }
  }

  return {
    init: init
  }
  
}();
